module.exports = __webpack_public_path__ + "static/img/mycompass_loginbkg_mnt3.1fa0afe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mycompass_loginbkg_mnt3.jpg
// module id = 0vm+
// module chunks = 0